import { FC } from 'react'
import type { IconProps } from '../types'

// prettier-ignore
const StatusReviewDraftIcon: FC<IconProps> = ({ size = 24 }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M9.3125 17.75L7.0625 20L4.8125 17.75H2V4.25H20V9M6.5 13.25H9.875M6.5 8.75H13.25'
      stroke='#A0A1AD'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M18 12C14.688 12 12 14.688 12 18C12 21.312 14.688 24 18 24C21.312 24 24 21.312 24 18C24 14.688 21.312 12 18 12ZM20.9121 16.245L19.755 15.0879C19.6382 14.9711 19.4492 14.9707 19.3319 15.0867L19.3307 15.0879L15.0879 19.3307C15.0316 19.387 15 19.4633 15 19.5429L15 20.7C15 20.8657 15.1343 21 15.3 21L16.4571 21C16.5367 21 16.613 20.9684 16.6693 20.9121L20.9121 16.6693C20.9684 16.613 21 16.5367 21 16.4571C21 16.3776 20.9684 16.3013 20.9121 16.245Z'
      fill='#717284'
    />
  </svg>
)

export default StatusReviewDraftIcon
